// extracted by mini-css-extract-plugin
export var baseButton = "_ve-0";
export var controlsArrowKeys = "_ve-1";
export var controlsResetButton = "_ve-2";
export var lightGameButton = "_ve-4 _ve-0";
export var playAgainButton = "_ve-5 _ve-0";
export var startGameButton = "_ve-3 _ve-0";